//@ts-ignore
import { onlyNumeric } from '@origin-digital/normalize';
import { Field } from 'formik';
import React from 'react';

import { alphaNumericTransform } from '../../../../utils/transforms';
import PostcodeField from '../PostcodeField';
import FormRow from '../FormRow';
import TextField from '../TextField';
import SelectField from '../SelectField';
import { ManualAddressProps } from './ManualAddress.types';

const ManualAddress: React.StatelessComponent<ManualAddressProps> = ({ ...props }: ManualAddressProps): JSX.Element => {
  const {
    metaData,
    asyncFetching,
    graphQuery,
    setAsyncFetching,
    productType,
    setDisqualification,
    showManualAddress,
    onGraphError,
    graphError,
    graphMessage,
    onFieldChange,
    recordDisqualification,
    disqualificationMessage
  } = props;

  return (
    <FormRow content={metaData.form.content.address} byline={metaData.form.content.address.byline} rowMarginBottom={0}>
      <Field
        name={metaData.form.fields.unit.name}
        component={TextField}
        label={metaData.form.fields.unit.label}
        maxLength={150}
      />
      <Field
        name={metaData.form.fields.streetNumber.name}
        component={TextField}
        label={metaData.form.fields.streetNumber.label}
        transform={alphaNumericTransform}
        maxLength={10}
      />
      <Field
        name={metaData.form.fields.streetName.name}
        component={TextField}
        label={metaData.form.fields.streetName.label}
        maxLength={150}
      />
      <Field
        name={metaData.form.fields.suburb.name}
        component={TextField}
        label={metaData.form.fields.suburb.label}
        maxLength={150}
      />
      <Field
        name={metaData.form.fields.state.name}
        component={SelectField}
        label={metaData.form.fields.state.label}
        options={metaData.form.fields.state.options}
      />
      <Field
        name={metaData.form.fields.postcode.name}
        label={metaData.form.fields.postcode.label}
        component={PostcodeField}
        productType={productType}
        showManualAddress={showManualAddress}
        onFieldChange={onFieldChange}
        transform={onlyNumeric}
        maxLength={4}
        spinner={asyncFetching}
        setAsyncFetching={setAsyncFetching}
        parseGraphResult={(data: any) => data.serviceable}
        graphQuery={graphQuery}
        graphError={graphError}
        graphMessage={graphMessage}
        onGraphError={onGraphError}
        disqualificationMessage={disqualificationMessage}
        setDisqualification={setDisqualification}
        recordDisqualification={recordDisqualification}
      />
    </FormRow>
  );
};

export { ManualAddress as default };
